/* =========================================================
   Pisae — Search by Breed
   クライアントサイド絞り込み / ひらがな⇄カタカナ⇄漢字対応
   ========================================================= */
(function () {
  'use strict';

  // ------- 犬種データ -------
  // name: 表示名 / reading: ひらがな読み / aliases: 別表記(漢字など)
  // tagName: Shopify の商品タグで使うマスター名 (犬種_{tagName})
  var BREEDS = [
    // あ行
    { row: 'あ行', name: 'アメリカンコッカースパニエル', reading: 'あめりかんこっかーすぱにえる', tagName: 'アメリカンコッカースパニエル', aliases: ['アメコカ','アメリカンコッカー'] },
    { row: 'あ行', name: 'イタリアングレーハウンド', reading: 'いたりあんぐれーはうんど', tagName: 'イタリアングレーハウンド', aliases: ['イタグレ','いたぐれ'] },
    { row: 'あ行', name: 'イングリッシュコッカースパニエル', reading: 'いんぐりっしゅこっかーすぱにえる', tagName: 'イングリッシュコッカースパニエル' },
    { row: 'あ行', name: 'イングリッシュセッター', reading: 'いんぐりっしゅせったー', tagName: 'イングリッシュセッター' },
    { row: 'あ行', name: 'ウエストハイランドホワイトテリア', reading: 'うえすとはいらんどほわいとてりあ', tagName: 'ウエストハイランドホワイトテリア', aliases: ['ウエスティ','ウェスティ','ウエスト・ハイランド・ホワイト・テリア'] },
    { row: 'あ行', name: 'オーストラリアンシェパード', reading: 'おーすとらりあんしぇぱーど', tagName: 'オーストラリアンシェパード', aliases: ['オージー','オーシー'] },
    { row: 'あ行', name: 'オーストラリアンラブラドゥードル', reading: 'おーすとらりあんらぶらどぅーどる', tagName: 'オーストラリアンラブラドゥードル' },
    // か行
    { row: 'か行', name: 'キャバリア', reading: 'きゃばりあ', tagName: 'キャバリア', aliases: ['キャバ','キャバリアキングチャールズスパニエル'] },
    { row: 'か行', name: 'グレートピレニーズ', reading: 'ぐれーとぴれにーず', tagName: 'グレートピレニーズ', aliases: ['ピレ'] },
    { row: 'か行', name: 'ケアーンテリア', reading: 'けあーんてりあ', tagName: 'ケアーンテリア', aliases: ['ケアーン'] },
    { row: 'か行', name: 'ゴールデンレトリバー', reading: 'ごーるでんれとりばー', tagName: 'ゴールデンレトリバー', aliases: ['ゴールデン','ゴールデンレトリーバー'] },
    { row: 'か行', name: 'コーイケルホンディエ', reading: 'こーいけるほんでぃえ', tagName: 'コーイケルホンディエ', aliases: ['コーイケル'] },
    { row: 'か行', name: 'コーギー', reading: 'こーぎー', tagName: 'コーギー', aliases: ['ウェルシュコーギー'] },
    // さ行
    { row: 'さ行', name: 'シーズー', reading: 'しーずー', tagName: 'シーズー' },
    { row: 'さ行', name: 'シェットランドシープドッグ', reading: 'しぇっとらんどしーぷどっぐ', tagName: 'シェットランドシープドッグ', aliases: ['シェルティ','シェルティー'] },
    { row: 'さ行', name: 'シェパード', reading: 'しぇぱーど', tagName: 'シェパード', aliases: ['ジャーマンシェパード'] },
    { row: 'さ行', name: 'ジャックラッセルテリア', reading: 'じゃっくらっせるてりあ', tagName: 'ジャックラッセルテリア', aliases: ['ジャック','ジャックラッセル'] },
    { row: 'さ行', name: '柴犬', reading: 'しばいぬ', tagName: '柴犬', aliases: ['柴','しば','シバ','赤柴','黒柴','白柴'] },
    { row: 'さ行', name: 'シベリアンハスキー', reading: 'しべりあんはすきー', tagName: 'シベリアンハスキー', aliases: ['ハスキー'] },
    { row: 'さ行', name: 'スキッパーキ', reading: 'すきっぱーき', tagName: 'スキッパーキ', aliases: [] },
    { row: 'さ行', name: 'スコティッシュテリア', reading: 'すこてぃっしゅてりあ', tagName: 'スコティッシュテリア', aliases: ['スコッチ','スコッチテリア'] },
    { row: 'さ行', name: 'スピッツ', reading: 'すぴっつ', tagName: 'スピッツ' },
    // た行
    { row: 'た行', name: 'ダップー', reading: 'だっぷー', tagName: 'ダップー', aliases: ['ダックスプー'] },
    { row: 'た行', name: 'ダルメシアン', reading: 'だるめしあん', tagName: 'ダルメシアン' },
    { row: 'た行', name: 'チワックス', reading: 'ちわっくす', tagName: 'チワックス', aliases: ['チワダックス','チワワダックス'] },
    { row: 'た行', name: 'チワプー', reading: 'ちわぷー', tagName: 'チワプー', aliases: ['チワワプードル'] },
    { row: 'た行', name: 'チワワ', reading: 'ちわわ', tagName: 'チワワ', aliases: ['ロングコートチワワ','スムースチワワ'] },
    { row: 'た行', name: 'トイプードル', reading: 'といぷーどる', tagName: 'トイプードル', aliases: ['プードル','ティーカッププードル','トイプー'] },
    // は行
    { row: 'は行', name: 'パグ', reading: 'ぱぐ', tagName: 'パグ' },
    { row: 'は行', name: 'パピヨン', reading: 'ぱぴよん', tagName: 'パピヨン' },
    { row: 'は行', name: 'バーニーズマウンテンドッグ', reading: 'ばーにーずまうんてんどっぐ', tagName: 'バーニーズマウンテンドッグ', aliases: ['バーニーズ'] },
    { row: 'は行', name: 'ビションプー', reading: 'びしょんぷー', tagName: 'ビションプー' },
    { row: 'は行', name: 'ビションフリーゼ', reading: 'びしょんふりーぜ', tagName: 'ビションフリーゼ', aliases: ['ビション'] },
    { row: 'は行', name: 'フラットコーテッドレトリバー', reading: 'ふらっとこーてっどれとりばー', tagName: 'フラットコーテッドレトリバー', aliases: ['フラッティ','フラットコーテッド'] },
    { row: 'は行', name: 'フレンチブルドッグ', reading: 'ふれんちぶるどっぐ', tagName: 'フレンチブルドッグ', aliases: ['フレブル','ブルドッグ'] },
    { row: 'は行', name: 'ペキニーズ', reading: 'ぺきにーず', tagName: 'ペキニーズ' },
    { row: 'は行', name: 'ボーダーコリー', reading: 'ぼーだーこりー', tagName: 'ボーダーコリー', aliases: ['ボーコリ'] },
    { row: 'は行', name: 'ボクサー', reading: 'ぼくさー', tagName: 'ボクサー' },
    { row: 'は行', name: 'ボストンテリア', reading: 'ぼすとんてりあ', tagName: 'ボストンテリア', aliases: ['ボステリ'] },
    { row: 'は行', name: 'ポメパピ', reading: 'ぽめぱぴ', tagName: 'ポメパピ' },
    { row: 'は行', name: 'ポメラニアン', reading: 'ぽめらにあん', tagName: 'ポメラニアン', aliases: ['ポメ'] },
    // ま行
    { row: 'ま行', name: 'マルチーズ', reading: 'まるちーず', tagName: 'マルチーズ', aliases: ['マルチ'] },
    { row: 'ま行', name: 'マルチワ', reading: 'まるちわ', tagName: 'マルチワ', aliases: ['マルチーズチワワ'] },
    { row: 'ま行', name: 'ミニチュアシュナウザー', reading: 'みにちゅあしゅなうざー', tagName: 'ミニチュアシュナウザー', aliases: ['シュナウザー','ミニシュナ'] },
    { row: 'ま行', name: 'ミニチュアダックスフンド', reading: 'みにちゅあだっくすふんど', tagName: 'ミニチュアダックスフンド', aliases: ['ダックス','ミニチュアダックス','ダックスフンド'] },
    { row: 'ま行', name: 'ミニチュアピンシャー', reading: 'みにちゅあぴんしゃー', tagName: 'ミニチュアピンシャー', aliases: ['ミニピン'] },
    // や行
    { row: 'や行', name: 'ヨークシャテリア', reading: 'よーくしゃてりあ', tagName: 'ヨークシャテリア', aliases: ['ヨーキー','ヨークシャー','ヨークシャーテリア'] },
    // ら行
    { row: 'ら行', name: 'ラブラドール', reading: 'らぶらどーる', tagName: 'ラブラドール', aliases: ['ラブラドールレトリバー','ラブ'] },
    // わ行
    { row: 'わ行', name: 'ワイマラナー', reading: 'わいまらなー', tagName: 'ワイマラナー', aliases: [] }
  ];

  var ROW_READINGS = {
    'あ行': 'A・I・U・E・O',
    'か行': 'KA・KI・KU・KE・KO',
    'さ行': 'SA・SHI・SU・SE・SO',
    'た行': 'TA・CHI・TSU・TE・TO',
    'な行': 'NA・NI・NU・NE・NO',
    'は行': 'HA・HI・FU・HE・HO',
    'ま行': 'MA・MI・MU・ME・MO',
    'や行': 'YA・YU・YO',
    'ら行': 'RA・RI・RU・RE・RO',
    'わ行': 'WA・WO'
  };

  // ------- 文字変換ユーティリティ -------
  function katakanaToHiragana(str) {
    return str.replace(/[\u30A1-\u30F6]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) - 0x60);
    });
  }
  function hiraganaToKatakana(str) {
    return str.replace(/[\u3041-\u3096]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) + 0x60);
    });
  }
  function normalize(str) {
    if (!str) return '';
    return katakanaToHiragana(String(str).toLowerCase())
      .replace(/[ー―‐\-\s　]/g, '');
  }

  // 検索マッチ判定
  function matchBreed(breed, query) {
    if (!query) return true;
    var q = normalize(query);
    if (!q) return true;
    var candidates = [
      breed.name,
      breed.reading,
      hiraganaToKatakana(breed.reading)
    ];
    if (breed.aliases) {
      candidates = candidates.concat(breed.aliases);
    }
    for (var i = 0; i < candidates.length; i++) {
      if (normalize(candidates[i]).indexOf(q) !== -1) return true;
    }
    // 漢字を含む場合、そのまま部分一致
    if (breed.name.indexOf(query) !== -1) return true;
    return false;
  }

  // ------- 初期化 -------
  function init() {
    var section = document.querySelector('[data-sbb-section]');
    if (!section) return;

    var listInner = section.querySelector('[data-sbb-list-inner]');
    var input = section.querySelector('[data-sbb-search]');
    var clearBtn = section.querySelector('[data-sbb-clear]');
    var resultsEl = section.querySelector('[data-sbb-results]');
    var resultsHeading = section.querySelector('[data-sbb-results-heading]');
    var resultsCount = section.querySelector('[data-sbb-results-count]');
    var resultsGrid = section.querySelector('[data-sbb-results-grid]');
    var resultsEmpty = section.querySelector('[data-sbb-results-empty]');
    var breadcrumbSelected = section.querySelector('[data-sbb-breadcrumb]');

    // 商品データ取得（section の内外どちらに配置されていても拾えるよう document スコープで）
    var productsJson = document.querySelector('[data-sbb-products-json]');
    var products = [];
    try {
      products = productsJson ? JSON.parse(productsJson.textContent || '[]') : [];
    } catch (err) {
      console.error('[search-by-breed] products JSON parse error:', err);
      products = [];
    }

    // 犬種ごとに商品カウント
    var countMap = {};
    products.forEach(function (p) {
      (p.breeds || []).forEach(function (b) {
        countMap[b] = (countMap[b] || 0) + 1;
      });
    });

    // ------- 犬種リスト描画 -------
    renderList();

    function renderList() {
      if (!listInner) return;
      var grouped = {};
      BREEDS.forEach(function (b) {
        if (!grouped[b.row]) grouped[b.row] = [];
        grouped[b.row].push(b);
      });

      var html = '';
      Object.keys(grouped).forEach(function (row) {
        html += '<div class="sbb__row" data-sbb-row="' + row + '">';
        html += '<h2 class="sbb__row-heading">' + row;
        if (ROW_READINGS[row]) {
          html += '<span class="sbb__row-heading-small">' + ROW_READINGS[row] + '</span>';
        }
        html += '</h2>';
        html += '<ul class="sbb__breeds">';
        grouped[row].forEach(function (b) {
          var count = countMap[b.tagName] || 0;
          var isEmpty = count === 0;
          var classes = 'sbb__breed-btn' + (isEmpty ? ' sbb__breed-btn--empty' : '');
          var countText = isEmpty ? '準備中' : count + 'アイテム';
          html += '<li class="sbb__breed" data-sbb-breed-name="' + escapeAttr(b.name)
            + '" data-sbb-breed-reading="' + escapeAttr(b.reading)
            + '" data-sbb-breed-tag="' + escapeAttr(b.tagName) + '">';
          html += '<button type="button" class="' + classes + '" '
            + 'data-sbb-breed-trigger '
            + 'data-empty="' + (isEmpty ? 'true' : 'false') + '">';
          html += '<span>' + b.name + '</span>';
          html += '<span class="sbb__breed-count">' + countText + '</span>';
          html += '</button></li>';
        });
        html += '</ul></div>';
      });
      html += '<p class="sbb__no-match" data-sbb-nomatch hidden>該当する犬種が見つかりません。<br>カスタム制作もご相談いただけます。</p>';

      listInner.innerHTML = html;

      // イベント委譲
      listInner.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sbb-breed-trigger]');
        if (!btn) return;
        var li = btn.closest('.sbb__breed');
        if (!li) return;
        var breed = findBreedByTag(li.getAttribute('data-sbb-breed-tag'));
        if (!breed) return;
        selectBreed(breed);
      });
    }

    function findBreedByTag(tagName) {
      for (var i = 0; i < BREEDS.length; i++) {
        if (BREEDS[i].tagName === tagName) return BREEDS[i];
      }
      return null;
    }

    // ------- 検索フィルタ -------
    function filter() {
      var q = input ? input.value : '';
      if (clearBtn) clearBtn.hidden = !q;

      var visibleCountPerRow = {};
      var breedEls = listInner.querySelectorAll('.sbb__breed');
      breedEls.forEach(function (el) {
        var name = el.getAttribute('data-sbb-breed-name');
        var breed = BREEDS.filter(function (b) { return b.name === name; })[0];
        var ok = breed && matchBreed(breed, q);
        el.classList.toggle('sbb__breed--hidden', !ok);
        if (ok) {
          var row = el.closest('[data-sbb-row]').getAttribute('data-sbb-row');
          visibleCountPerRow[row] = (visibleCountPerRow[row] || 0) + 1;
        }
      });

      var rows = listInner.querySelectorAll('[data-sbb-row]');
      var anyVisible = false;
      rows.forEach(function (rowEl) {
        var row = rowEl.getAttribute('data-sbb-row');
        var count = visibleCountPerRow[row] || 0;
        rowEl.classList.toggle('sbb__row--empty', count === 0);
        if (count > 0) anyVisible = true;
      });

      var nomatch = listInner.querySelector('[data-sbb-nomatch]');
      if (nomatch) nomatch.hidden = anyVisible;
    }

    if (input) {
      input.addEventListener('input', filter);
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (!input) return;
        input.value = '';
        filter();
        input.focus();
      });
    }

    // ------- 犬種選択 -------
    function selectBreed(breed) {
      // active 状態
      var btns = listInner.querySelectorAll('.sbb__breed-btn');
      btns.forEach(function (b) { b.removeAttribute('aria-current'); });
      var activeLi = listInner.querySelector('[data-sbb-breed-tag="' + cssEscape(breed.tagName) + '"]');
      if (activeLi) {
        var activeBtn = activeLi.querySelector('.sbb__breed-btn');
        if (activeBtn) activeBtn.setAttribute('aria-current', 'true');
      }

      // パンくず更新
      if (breadcrumbSelected) {
        breadcrumbSelected.textContent = breed.name;
        breadcrumbSelected.hidden = false;
      }

      // 該当商品
      var matched = products.filter(function (p) {
        return (p.breeds || []).indexOf(breed.tagName) !== -1;
      });

      if (resultsHeading) resultsHeading.textContent = breed.name + 'の商品';
      if (resultsCount) resultsCount.textContent = matched.length + 'アイテム';

      if (matched.length === 0) {
        if (resultsGrid) resultsGrid.innerHTML = '';
        if (resultsEmpty) resultsEmpty.hidden = false;
      } else {
        if (resultsEmpty) resultsEmpty.hidden = true;
        renderCards(matched);
      }

      if (resultsEl) {
        resultsEl.hidden = false;
        // スムーススクロール
        setTimeout(function () {
          resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 40);
      }

      // URL更新 (履歴に残す、戻るで解除)
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('breed', breed.tagName);
        window.history.pushState({ breed: breed.tagName }, '', url.toString());
      } catch (e) { /* noop */ }
    }

    function renderCards(list) {
      if (!resultsGrid) return;
      var html = list.map(function (p) {
        var priceHtml = p.price || '';
        if (p.compare_at_price && p.compare_at_price !== p.price) {
          priceHtml = '<span class="sbb-card__price-compare">' + p.compare_at_price + '</span>' + p.price;
        }
        var hoverImg = p.image_hover
          ? '<img class="sbb-card__img sbb-card__img--hover" src="' + escapeAttr(p.image_hover) + '" alt="" loading="lazy" />'
          : '';
        var reviewText = renderReviewStars(p.review_count);
        return ''
          + '<a class="sbb-card" href="' + escapeAttr(p.url) + '">'
          +   '<div class="sbb-card__media">'
          +     (p.image ? '<img class="sbb-card__img" src="' + escapeAttr(p.image) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" />' : '')
          +     hoverImg
          +   '</div>'
          +   '<div class="sbb-card__body">'
          +     (p.type ? '<p class="sbb-card__type">' + escapeHtml(p.type) + '</p>' : '')
          +     '<h3 class="sbb-card__title">' + escapeHtml(p.title) + '</h3>'
          +     (reviewText ? '<p class="sbb-card__reviews">' + reviewText + '</p>' : '')
          +     '<p class="sbb-card__price">' + priceHtml + '</p>'
          +   '</div>'
          + '</a>';
      }).join('');
      resultsGrid.innerHTML = html;
    }

    // ------- 戻る対応 -------
    window.addEventListener('popstate', function () {
      var url = new URL(window.location.href);
      var bt = url.searchParams.get('breed');
      if (!bt) {
        if (resultsEl) resultsEl.hidden = true;
        var btns2 = listInner.querySelectorAll('.sbb__breed-btn');
        btns2.forEach(function (b) { b.removeAttribute('aria-current'); });
        if (breadcrumbSelected) {
          breadcrumbSelected.textContent = '';
          breadcrumbSelected.hidden = true;
        }
      } else {
        var b = findBreedByTag(bt);
        if (b) selectBreedQuiet(b);
      }
    });

    function selectBreedQuiet(breed) {
      // pushState なしで結果だけ再描画
      var matched = products.filter(function (p) {
        return (p.breeds || []).indexOf(breed.tagName) !== -1;
      });
      if (resultsHeading) resultsHeading.textContent = breed.name + 'の商品';
      if (resultsCount) resultsCount.textContent = matched.length + 'アイテム';
      if (matched.length === 0) {
        if (resultsGrid) resultsGrid.innerHTML = '';
        if (resultsEmpty) resultsEmpty.hidden = false;
      } else {
        if (resultsEmpty) resultsEmpty.hidden = true;
        renderCards(matched);
      }
      if (resultsEl) resultsEl.hidden = false;
      if (breadcrumbSelected) {
        breadcrumbSelected.textContent = breed.name;
        breadcrumbSelected.hidden = false;
      }
    }

    // ------- URLパラメータ初期化 -------
    try {
      var initUrl = new URL(window.location.href);
      var initBreed = initUrl.searchParams.get('breed');
      if (initBreed) {
        var found = findBreedByTag(initBreed);
        if (found) selectBreedQuiet(found);
      }
    } catch (e) { /* noop */ }
  }

  // ------- helpers -------
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function escapeAttr(str) {
    return escapeHtml(str);
  }
  function cssEscape(str) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(str);
    return String(str).replace(/"/g, '\\"');
  }

  // Judge.me badge HTML から星評価を抽出して、自前の黄色★に置き換える
  function renderReviewStars(badgeHtml) {
    if (!badgeHtml) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = badgeHtml;
    var badge = tmp.querySelector('[data-average-rating]');
    if (!badge) return '';
    var rating = parseFloat(badge.getAttribute('data-average-rating')) || 0;
    var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    if (!count || count <= 0) return '';
    var rounded = Math.round(rating);
    if (rounded < 0) rounded = 0;
    if (rounded > 5) rounded = 5;
    var on = '';
    var off = '';
    for (var i = 0; i < rounded; i++) on += '★';
    for (var j = 0; j < 5 - rounded; j++) off += '★';
    return ''
      + '<span class="sbb-card__stars" aria-label="' + rating + ' / 5 stars">'
      +   '<span class="sbb-card__stars-on">' + on + '</span>'
      +   '<span class="sbb-card__stars-off">' + off + '</span>'
      + '</span>'
      + '<span class="sbb-card__review-count">(' + count + ')</span>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// rebuild 1780000002 chiwax-chiwapoo
